module.exports = __webpack_public_path__ + "fonts/AmbulatoriaD-SemiBold.ed269350.woff2";